import { Subscription } from "../../interfaces";

const calculateTickets = (subscriptions: any) => {
    let totalTickets = 0
    if (subscriptions.length < 1) return 0;
    subscriptions.forEach((subscription: any) => {
        if (subscription.isVerified && subscription.status === "locked") {
            let expiresAt = new Date(subscription.expiresAt).getTime();
            if (expiresAt > new Date().getTime()) {
                totalTickets += subscription.tickets;
            }
        }
    });
    return totalTickets;
}

const calculateLockedGains = (subscriptions: any) => {
    return subscriptions
        .filter((subscription: any) => subscription.isVerified && (new Date(subscription.expiresAt) > new Date()))
        .reduce((amt: any, curr: any) => amt + curr.totalToken, 0)
}


const calculateUnlockedGains = (subscriptions: any) => {
    return subscriptions
    .filter((subscription: any) => subscription.isVerified && (new Date(subscription.expiresAt) <= new Date()))
    .reduce((amt: any, curr: any) => amt + curr.totalToken, 0)
}

const SubscriptionReducer = (state: any, action: any) => {
    switch(action.type) {
        case 'GET_SUBSCRIPTIONS': {
            return {
                ...state,
                subscriptions: action.payload,
                totalTickets: calculateTickets(action.payload),
                lockedGainsPad: calculateLockedGains(action.payload),
                unlockedGains: calculateUnlockedGains(action.payload)
            }
        }
        case 'SET_TOTAL_LOCKED_GAINS': {
            return {
                ...state,
                lockedGains: action.payload
            }
        }
        case 'UPDATE_SUBSCRIPTIONS': {
            return {
                ...state,
                subscriptions: [ action.payload, ...state.subscriptions ],
                pendingSubscriptions: state.pendingSubscriptions.filter((subscription: Subscription) => subscription.id !== action.payload.id),
                totalTickets: state.totalTickets + action.payload.tickets,
                lockedGains: state.lockedGains + action.payload.totalToken,
                lockedGainsPad: state.lockedGainsPad + action.payload.totalToken,
                awaitingLock: false,
            };
        }
        case 'NEW_SUBSCRIPTION': {
            return {
                ...state,
                pendingSubscriptions: [ ...state.pendingSubscriptions, action.payload ],
                awaitingLock: true,
            }
        }
        case 'CANCEL_PENDING_SUBSCRIPTION': {
            return {
                ...state,
                pendingSubscriptions: state.pendingSubscriptions.filter((subscription: Subscription) => subscription.id !== action.payload),
                awaitingLock: false,
            }
        }
        case 'CLEAR_SUBSCRIPTIONS': {
            return state;
        }
        case 'UPDATE_SUBSCRIPTION_STEP': {
            return {
                ...state,
                step: action.payload
            }
        }
        default: {
            return state;
        }
    }
}

export default SubscriptionReducer;